import { Component } from '@theme/component';

/**
 * @typedef {Object} ProductDescriptionTeaserRefs
 * @property {HTMLElement} summary - Truncated summary container
 * @property {HTMLElement} full - Full description container
 * @property {HTMLButtonElement} readMore - Read more button
 */

/**
 * Expands truncated product description on PDP.
 *
 * @extends {Component<ProductDescriptionTeaserRefs>}
 */
class ProductDescriptionTeaser extends Component {
  /**
   * @param {Event} event
   */
  expand(event) {
    event.preventDefault();

    const { summary, full } = this.refs;

    if (summary) summary.hidden = true;
    if (full) full.hidden = false;
  }
}

if (!customElements.get('product-description-teaser')) {
  customElements.define('product-description-teaser', ProductDescriptionTeaser);
}
